import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex';
import * as types from '@reserve/store/types'
import { getResourceColor } from '@reserve/store/consts'
import * as popupHelper from '@appbase/util/popup-helper';

@Component({
    computed: mapGetters({
        isLoading: types.CALENDAR_LOADING,
        selectedResourceKeys: types.SELECTED_RESOURCE_KEYS,        
    }),

    methods: mapActions({
        selectResource: types.TOGGLE_RESOURCE_SELECT
    })
})
export default class ResourceItem  extends Vue {
    @Prop({ type: Object }) item!: ewsResource.EwsResourceItem;

    selectResource!: (payload: { category: 'EWS' | 'DB' | 'FAVORITE', id: string, select: boolean }) => void;

    selectedResourceKeys!: string[];
    isLoading!: boolean;    

    selected: boolean = false;
    colorCodeClass: any = {};

    @Watch('selectedResourceKeys')
    OnSelectChanged(newVal: string[]) {
        this.selected = newVal.indexOf(this.item.uniqueId) >= 0;
        this.colorCodeClass[this.item.colorCode] = this.selected;
    }
    
    created() {
        this.selected = this.item.selected || false;        
        this.colorCodeClass[this.item.colorCode] = this.selected;

        this.OnSelectChanged(this.selectedResourceKeys);
    }

    selectChanged() {
        this.selectResource({ category: 'EWS', id: this.item.uniqueId, select: this.selected });
    }

    getColorCode(code: string | null) {
        if(this.selected) {
            return code == null ?
                getResourceColor(this.item.uniqueId) : code;
        } else {    
            return null;
        }
    }

    onInformationClick(){
        popupHelper.openPopup(`resourceInfo_${this.item.uniqueId}`, "/reservePopup/info",
            {
                uniqueId: this.item.uniqueId
            },
            {
                width: 620,
                height: 700,
                isFrame: this.isTeams
        })        
    }
}